import { useEffect } from "react";
import { NestedCriteriaBuilder } from "./NestedCriteriaBuilder";
import { useAppDispatch } from "../../../Redux/hooks";
import { toggleSidebarCollapse } from "../../../Redux/reducers/appSlice";

const CohortBuilder = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(toggleSidebarCollapse(true));
    return () => {
      dispatch(toggleSidebarCollapse(false));
    };
  }, [dispatch]);

  return <NestedCriteriaBuilder type="registry" />;
};

export default CohortBuilder;
